
// Define a function to initialize tooltips
function initializeTooltips() {
  // Get all elements with the 'tooltip-trigger' class
  const tooltipTriggers = document.querySelectorAll('.tooltip-trigger');
  // Iterate through each tooltip trigger
  tooltipTriggers.forEach(initializeTooltip);
}

// Define a function to initialize a single tooltip
function initializeTooltip(trigger) {
  const clickable = trigger.getAttribute("clickable");
  console.log("clickable", clickable);
  // Get the tooltip text from the 'data-tooltip' attribute
  const tooltipText = trigger.getAttribute('data-tooltip');

  const tooltipPosition = trigger.getAttribute('tooltip-position');
  console.log("tooltipPosition", tooltipPosition);

  // Create a new tooltip element
  const tooltip = document.createElement('span');
  if(tooltipPosition){
    tooltip.className = 'tooltip top';
  } else {
    tooltip.className = 'tooltip';
  }
  
  tooltip.innerHTML = tooltipText;

  // Append the tooltip to the trigger's container
  trigger.appendChild(tooltip);

  // Add event listeners to show/hide the tooltip on hover
  trigger.addEventListener('mouseenter', function (event) {
    showTooltip(tooltip);
    if(clickable) {
      if (!tooltip.classList.contains('hold')) {
        updateTooltipPosition(event, trigger, tooltip, tooltipPosition);
      }
    } else {
      updateTooltipPosition(event, trigger, tooltip, tooltipPosition);
    }
    
  });
  trigger.addEventListener('mouseleave', function () {
    hideTooltip(tooltip);
  });
  trigger.addEventListener('mousemove', function (event) {
    if(clickable) {
      if (!tooltip.classList.contains('hold')) {
        updateTooltipPosition(event, trigger, tooltip, tooltipPosition);
      }
    } else {
      updateTooltipPosition(event, trigger, tooltip, tooltipPosition);
    }
  });
  if(clickable) {
    trigger.addEventListener('click', function (event) {
      console.log("tooltip", tooltip);
      tooltip.classList.toggle('hold');
      // updateTooltipPosition(event, trigger, tooltip, tooltipPosition);
    });
  }
}

// Define a function to show the tooltip
function showTooltip(tooltip) {
  tooltip.classList.add('show');
}

// Define a function to hide the tooltip
function hideTooltip(tooltip) {
  tooltip.classList.remove('show');
}

function updateTooltipPosition(event, trigger, tooltip, position) {
  const xOffset = -8; // Adjust this value to set the horizontal offset
  let yOffset = 35; // Adjust this value to set the vertical offset
  console.log("position", position);
  if(position == "top") {
    yOffset = -55;
  }

  const rect = trigger.getBoundingClientRect();

  const mouseX = event.clientX - rect.left + xOffset;
  const mouseY = event.clientY - rect.top + yOffset;

  tooltip.style.left = mouseX + 'px';
  tooltip.style.top = mouseY + 'px';
}

function isMobileDevice() {
  return window.matchMedia('(max-width: 500px)').matches;
}

if (isMobileDevice()) {
  //console.log('This is a mobile device.');
} else {
  // Use DOMContentLoaded to ensure the document is fully loaded before initializing tooltips
  document.addEventListener('DOMContentLoaded', initializeTooltips);
}
